export default ngModule => {

  /**
   * Add a custom error message resolver so we can customise error messages easily.
   *
   * Use in coordination with the applyValidators directive (see form-directives.js)
   */
  ngModule
    .factory('ErrorMessageResolver', [
      '$q',
      function ($q) {

        let defaultMessages = {};
        const resolve = (errorType, el) => {
          var defer = $q.defer();
          const elementMessages = el.data('validation-messages') || {},
                validation = el.data('validation') || {},
                validator_details = validation[errorType],
                result = (elementMessages[errorType] || defaultMessages[errorType] || defaultMessages['default']);
          if (result) {
            defer.resolve(result.replace('{0}', validator_details));
          } else {
            defer.resolve('Set error message for '+errorType)
          }
          return defer.promise;
        };

        return {
          resolve: resolve,
          setDefaultMessages: (messages) => {
            defaultMessages = messages;
            defaultMessages['date'] = 'That is not a valid date';
            defaultMessages['medicare_number'] = 'That is not a valid medicare number.';
          }
        };
      }
    ]);

  }


// WEBPACK FOOTER //
// ./src/services/error-message-service.js